// @ts-nocheck
import { Button, FormControlLabel, Switch, TextField } from "@material-ui/core";
import axiosWithAuthInterceptor from '../util/axiosWithAuthInterceptor';
import * as React from "react";
import { useForm, useWatch } from "react-hook-form";

type NetworkState = "PENDING" | "SUCCEED" | "FAILED" | "IDLE";

// utils/validators.js

export const SNToValidator = (SNFrom, SNTo) => {
  if (SNFrom && SNTo && SNFrom > SNTo) {
    return `باید بیشتر "از سریال نامبر از" باشد`;
  }
};

export const SNFromValidator = (SNFrom, SNTo) => {
  if (SNFrom && SNTo && SNFrom > SNTo) {
    return `باید کمتر "از سریال نامبر تا" باشد`;
  }
};

interface IFormInput {
  SNFrom: string;
  SNTo: string;
  defaultPrice: number;
  isEnabled: boolean;
  isFree: boolean;
}

export function EditLimooCard() {
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    control,
    formState: { errors, isValid },
  } = useForm<IFormInput>({
    mode: "onChange",
    defaultValues: {
      SNTo: null,
      SNFrom: null,
      defaultPrice: null,
      isEnabled: true,
      isFree: false,
    },
  });

  const [errorMessages, setErrorMessages] = React.useState([]);
  const [networkState, setNetworkState] = React.useState<NetworkState>("IDLE");

  const ERROR_MESSAGES_TRANSLATE = {
    "marketer-mobile-not-found": "شماره بازاریاب یافت نشد",
    "marketer-mobile-is-invalid": "شماره بازاریاب صحیح نمیباشد",
    "seller-mobile-not-found": "شماره فروشنده یافت نشد",
    "seller-mobile-is-invalid": "شماره فروشنده صحیح نمیباشد",
  };

  const onSubmit = async (data: IFormInput) => {
    setErrorMessages([]);
    let token: any = localStorage.getItem("credentials");
    const url = `${process.env.REACT_APP_LEMONADE_SERVER}/api/discounts/limoo-cards/bulk`;

    let patchData = {
      serialNumberFrom: data.SNFrom,
      serialNumberTo: data.SNTo,
      isEnabled: data.isEnabled,
    };

    if (data.isFree) {
      patchData = {
        ...patchData,
        defaultPrice: 0,
        seller: {
          price: 0,
        },
      };
    } else {
      patchData = {
        ...patchData,
        defaultPrice: data.defaultPrice,
      };
    }



    try {
      setNetworkState("PENDING");
      const { data } = await axiosWithAuthInterceptor({
        url: url,
        data: patchData,
        method: "PATCH",
      });

      if (data.err) {
        throw data;
      }
      setNetworkState("SUCCEED");
    } catch (error) {
      if (error.err) {
        setErrorMessages([...error.err.details.messages]);
      }
      setNetworkState("FAILED");
    }
  };



  const isEnabled = useWatch({
    control: control,
    name: "isEnabled",
  });

  const isFree = useWatch({
    control: control,
    name: "isFree",
  });

  if (isFree) {
    setValue("defaultPrice", 0);
  }

  const validateSNTo = () => {
    return SNToValidator(watch("SNFrom"), watch("SNTo"));
  };

  const validateSNFrom = () => {
    return SNFromValidator(watch("SNFrom"), watch("SNTo"));
  };

  // const validateDefaultPriceRequired = () => {
  //   if (isFree) {
  //     return true;
  //   } 
  //   return "در کنار مبلغ فروشنده، شماره فروشنده هم باید ارسال شود";
  // };



  return (
    <div style={{ padding: "1rem" }}>
      <form
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
          direction: "rtl",
        }}
        onSubmit={handleSubmit(onSubmit)}
      >
        <TextField
          {...register("SNFrom", {
            required: true,
            valueAsNumber: true,
            validate: {
              checkOrder: validateSNFrom,
            },
          })}
          error={!!errors.SNFrom}
          helperText={errors.SNFrom ? errors.SNFrom.message : null}
          fullWidth
          label="از سریال نامبر"
          variant="outlined"
        />

        <TextField
          {...register("SNTo", {
            required: true,
            valueAsNumber: true,
            validate: {
              checkOrder: validateSNTo,
            },
          })}
          fullWidth
          error={!!errors.SNTo}
          helperText={errors.SNTo ? errors.SNTo.message : null}
          label="تا سریال نامبر"
          variant="outlined"
        />

        <TextField
          {...register("defaultPrice", {
            valueAsNumber: true,
          })}
          error={!!errors.defaultPrice}
          helperText={errors.defaultPrice ? errors.defaultPrice.message : null}
          fullWidth
          label="قیمت پیشفرض (تومان)"
          variant="outlined"
          disabled={isFree}
        />

        <FormControlLabel
          control={
            <Switch
              checked={isEnabled}
              onChange={(e) => setValue("isEnabled", e.target.checked)}
              color="primary"
            />
          }
          label="فعال/ غیرفعال"
        />

        <FormControlLabel
          control={
            <Switch
              checked={isFree}
              onChange={(e) => setValue("isFree", e.target.checked)}
              color="primary"
            />
          }
          label="رایگان"
        />

        <Button
          disabled={!isValid || networkState === "PENDING"}
          fullWidth
          type="submit"
          color="primary"
          variant="contained"
        >
          ثبت
        </Button>

        {networkState === "SUCCEED" && <p>اطلاعات شما با موفقیت ثبت شد</p>}
        {networkState === "PENDING" && <p>در حال ارسال اطلاعات ...</p>}
        {networkState === "FAILED" &&
          (errorMessages.length > 0 ? (
            errorMessages.map((message) =>
              ERROR_MESSAGES_TRANSLATE[message] ? (
                <p>{ERROR_MESSAGES_TRANSLATE[message]}</p>
              ) : (
                <p>خطایی رخ داده لطفا مجددا تلاش نمایید</p>
              )
            )
          ) : (
            <p>خطایی رخ داده لطفا مجددا تلاش نمایید</p>
          ))}
      </form>
    </div>
  );
}
